import React, { createRef } from 'react'
import { SupplierDiscoveryStyle } from './styled'
import {
  Button,
  Image,
  Section,
  Tabber,
  SelectBox,
  InputSearch,
  Tag,
  Spinner,
  Modal,
  Table,
  Breadcrumbs,
  Loading,
} from '../../components'
import { supplierController } from '../../apiService'
import { SupplierDiscoveryBlock } from './SupplierDiscoveryBlock'
import { MainDirectoryBlock } from './MainDirectoryBlock'
import { ICONS } from '../../themes'
import { SidebarFilter } from './SidebarFilter'
import { STRING, ROUTE_PATH, formatNumberWithComma } from '../../helpers'
import { toast } from 'react-toastify'
import { store } from 'store'
import {
  addSearchTag,
  removeSearchTag,
  clearSearchTag,
  selectTab,
} from '../../store/actions'
import {
  insertSearchFilter,
  clearSearchFilter,
} from '../../store/searchfilter/actions'
const defaultSidebarFilter = {
  categories: [],
  businessType: null,
  isCheckedRegisCapital: false,
  registeredCapital: null,
  isCheckedYearEstablished: false,
  yearEstablished: null,
  financialScore: null,
  sustainabilityScore: null,
  riskLevelScore: null,
}
import { DebounceInput } from 'react-debounce-input'
const SORT_BY_OPTIONS = [
  { value: '1', label: STRING.UPDATE_DATE_DESC },
  { value: '2', label: STRING.UPDATE_DATE_ASC },
  { value: '3', label: STRING.RISK_LEVEL_DESC },
  { value: '4', label: STRING.RISK_LEVEL_ASC },
]

export class SupplierDiscoveryContainer extends React.Component {
  _isMounted = false
  constructor(props) {
    super(props)
    this.inputSearch = createRef()
    this.state = {
      openModalContact: false,
      tabIndex: 0,
      supplierListLoading: true,
      mainDirectoryListLoading: true,
      supplierList: [],
      mainDirectoryList: [],
      supplierPage: null,
      mainDirectoryPage: null,
      selectsupplierList: [],
      sidebarFilter: defaultSidebarFilter,
      // if none inside group, do not need className
      optionsSortBy: SORT_BY_OPTIONS,
      categoryValue: '',
      searchTags: [],
      searchInput: '',
      supplierDetail: {},
      sortByValue: SORT_BY_OPTIONS[0],
    }
    this.renderSupplierDiscovery = this.renderSupplierDiscovery.bind(this)
  }
  componentDidMount() {
    this._isMounted = true
    this._fetchTabData()
    window.addEventListener('scroll', this._handleScroll.bind(this))
  }

  componentWillUnmount() {
    this._isMounted = false
    window.removeEventListener('scroll', this._handleScroll.bind(this))
  }

  _handleScroll() {
    if (!this._isMounted) {
      window.removeEventListener('scroll', this._handleScroll.bind(this))
      return
    }
    const offsetTrigger = 200
    const docElm = document.documentElement
    const scrollBottom =
      docElm.scrollHeight - (docElm.scrollTop + docElm.clientHeight)
    if (scrollBottom <= offsetTrigger && !this.isScrollBottom) {
      this.isScrollBottom = true
      this._onScrollBottom()
    } else if (scrollBottom > offsetTrigger) {
      this.isScrollBottom = false
    }
  }

  _onScrollBottom() {
    if (!this.state.supplierListLoading) {
      this._fetchTabData(true)
    }
  }

  async _fetchTabData(isLoadNextPage = false) {
    const { selectTab } = store.getState()
    if (selectTab === 0) {
      if (isLoadNextPage && this.state.supplierPage) {
        if (this.state.supplierPage.next_page > this.state.supplierPage.page) {
          await this._fetchSupplier(this.state.supplierPage.next_page)
        }
      } else {
        await this._fetchSupplier(1)
      }
    } else {
      if (isLoadNextPage && this.state.mainDirectoryPage) {
        if (
          this.state.mainDirectoryPage.next_page >
          this.state.mainDirectoryPage.page
        ) {
          await this._fetchMainDirectory(this.state.mainDirectoryPage.next_page)
        }
      } else {
        await this._fetchMainDirectory(1)
      }
    }
  }

  _paramsFilter() {
    // service_category
    const { searchFilter } = store.getState()
    const service_category = []
    searchFilter.categories.forEach(c => {
      c.sub_categories.forEach(sc => {
        service_category.push(sc.id)
      })
    })
    // business_type
    const business_type = []
    if (searchFilter.businessType) {
      searchFilter.businessType.forEach(i => {
        business_type.push(i.id)
      })
    }
    // min_regis_capital
    let min_regis_capital = -1
    if (searchFilter.isCheckedRegisCapital) {
      min_regis_capital = searchFilter.registeredCapital[0]
    }
    // max_regis_capital
    let max_regis_capital = -1
    if (searchFilter.isCheckedRegisCapital) {
      max_regis_capital = searchFilter.registeredCapital[1]
    }
    // year_establishes
    let year_established = null
    if (searchFilter.isCheckedYearEstablished) {
      year_established = searchFilter.yearEstablished
    }
    // regulatory
    const regulatory_risk = []
    if (searchFilter.regulatoryRisk) {
      searchFilter.regulatoryRisk.forEach(i => {
        regulatory_risk.push(i)
      })
    }
    return {
      service_category: service_category.length ? service_category : null,
      business_type: business_type.length ? business_type : null,
      min_regis_capital,
      max_regis_capital,
      year_established,
      financial_score: searchFilter.financialScore,
      sustainability: searchFilter.sustainabilityScore || [],
      operational: searchFilter.operationRiskScore || [],
      offline_assessment: searchFilter.offlineAssessment || [],
      online_assessment: searchFilter.onlineAssessment || [],
      search: store.getState().searchTags,
      sort_by: parseInt(this.state.sortByValue.value),
      risk_score: searchFilter.riskLevelScore,
      regulatory: regulatory_risk || [],
    }
  }

  _fetchSupplier = page => {
    if (this._isMounted) {
      this.setState({ supplierListLoading: true })
    }
    const funcFetchData = async () => {
      const params = this._paramsFilter()
      const resultSearch = await supplierController().supplierList({
        page,
        ...params,
      })
      if (typeof resultSearch.records !== 'undefined') {
        const { records, ...page } = resultSearch
        if (this._isMounted) {
          return this.setState({
            supplierList: [...this.state.supplierList, ...records],
            supplierPage: page,
            supplierListLoading: false,
          })
        }
      }
    }
    try {
      return funcFetchData()
    } catch (error) {
      console.log(error)
    }
  }

  _fetchsupplierCompanyRfq() {
    return this.state.selectsupplierList
  }

  _fetchsupplierdeleteRfq(id) {
    return supplierController()
      .supplierdeleteRfq(id)
      .then(res => {
        this.toastActive('delete complete')
        if (this._isMounted) {
          this.setState({
            supplierListLoading: false,
          })
        }
      })
      .finally(() => {
        if (this._isMounted) {
          this.setState({ supplierListLoading: false })
        }
      })
  }

  _fetchsupplierdeleteRfqAll(id) {
    return supplierController()
      .supplierdeleteRfq(id)
      .then(res => {
        if (this._isMounted) {
          this.setState({
            supplierListLoading: false,
          })
        }
      })
      .finally(() => {
        if (this._isMounted) {
          this.setState({ supplierListLoading: false })
        }
      })
  }

  _fetchsupplieraddToRfq(id) {
    return supplierController()
      .supplieraddToRfq(id)
      .then(res => {
        this.toastActive('Supplier was selected to supplier list')
        if (this._isMounted) {
          this.setState({
            supplierListLoading: false,
          })
        }
      })
      .finally(() => {
        if (this._isMounted) {
          this.setState({ supplierListLoading: false })
        }
        // setTimeout(this._fetchsupplierCompanyRfq(), 500)
      })
  }

  _fetchMainDirectory(page) {
    if (this._isMounted) {
      this.setState({ mainDirectoryListLoading: true })
    }
    const params = this._paramsFilter()
    return supplierController()
      .mainDirectoryList({ page, ...params })
      .then(({ records, ...page }) => {
        this.state.mainDirectoryList.push(...records)
        // this.state.mainDirectoryList = { ...this.state.mainDirectoryList , ...records}
        if (this._isMounted) {
          this.setState({
            mainDirectoryList: this.state.mainDirectoryList,
            mainDirectoryPage: page,
            mainDirectoryListLoading: false,
          })
        }
      })
      .finally(() => {
        if (this._isMounted) {
          this.setState({ mainDirectoryListLoading: false })
        }
      })
  }

  _onChangeFilters(filters) {
    if (this._isMounted) {
      this.setState({
        supplierList: [],
        supplierPage: { page: 1 },
        mainDirectoryList: [],
        mainDirectoryPage: { page: 1 },
      })
    }
    clearTimeout(this.fetchTabDataTimeout)

    this.fetchTabDataTimeout = setTimeout(() => {
      this._fetchTabData()
    }, 500)
  }

  _onChangeSortBy(value) {
    if (this._isMounted) {
      this.setState(
        {
          optionsSortByValue: value,
          supplierListLoading: true,
          sortByValue: value,
        },
        () => {
          this._onChangeFilters({
            optionsSortByValue: value,
          })
        }
      )
    }
  }

  _onChangeSidebarFilter(payload) {
    // console.log('payload', payload)
    this.setState({ supplierListLoading: true })
    store.dispatch(insertSearchFilter(payload))
    if (this._isMounted) {
      this.setState(
        {
          searchTags: [],
          searchInput: '',
        },
        () => {
          this._onChangeFilters()
        }
      )
    }
  }

  _onChangeTab(tabIndex) {
    store.dispatch(clearSearchTag())
    store.dispatch(clearSearchFilter())
    this.clearInputValue()
    store.dispatch(selectTab(tabIndex))
    if (this._isMounted) {
      this.setState(
        {
          tabIndex,
          searchInput: '',
          supplierList: [],
          supplierPage: { page: 1 },
          mainDirectoryList: [],
          mainDirectoryPage: { page: 1 },
          sortByValue: SORT_BY_OPTIONS[0],
        },
        () => {
          this._fetchTabData()
        }
      )
    }
  }

  async _addSupplierList(info) {
    const { id } = this.state.supplierDetail
    try {
      const res = await supplierController().addSupplierListId(id)
      if (res && res.status === 'AddSuccess') {
        const mainDirectoryList = [...this.state.mainDirectoryList]
        const index = mainDirectoryList.findIndex(i => id === i.id)
        mainDirectoryList[index].status = 'Unavailable'
        if (this._isMounted) {
          this.setState({ mainDirectoryList }, () => {
            toast('Supplier was added successfully', {
              position: 'top-center',
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: undefined,
              type: 'success',
            })
          })
          this.setState({ modalAddMySupplier: false })
        }
      }
    } catch (error) {
      throw new Error(error)
    }
  }

  setList = e => {
    let id = e.my_supplier_id
    this._fetchsupplieraddToRfq(id)
  }

  toastActive = e => {
    toast(e, {
      position: 'top-center',
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      progress: undefined,
      type: 'success',
    })
  }

  deleteCart = e => {
    let id = e.Id
    this._fetchsupplierdeleteRfq(id)
  }
  deleteCartAll = () => {
    // let id = this.state.selectsupplierList.filter(e => {
    //   this._fetchsupplierdeleteRfqAll(parseInt(e.Id))
    // })

    setTimeout(this.toastActive('delete all complete'), 1000)
  }

  _renderSupplierList() {
    return (
      <div className="list-render">
        {this.state.supplierList.map(source => (
          <SupplierDiscoveryBlock
            key={source.my_supplier_id}
            info={source}
            // selectsupplierList={this.state.selectsupplierList}
            onIconClick={info => {
              if (this._isMounted) {
                this.setState({
                  modalContact: info,
                  openModalContact: true,
                })
              }
            }}
            onIconWarning={info => {
              if (this._isMounted) {
                this.setState({
                  modalWarning: info,
                })
              }
            }}
            supplierList={e => {
              this.setList(e)
            }}
          />
        ))}
      </div>
    )
  }

  _renderMainDirectoryList() {
    return (
      <div className="list-render">
        {this.state.mainDirectoryList.map(source => (
          <MainDirectoryBlock
            key={source.id}
            info={source}
            // selectsupplierList={this.state.selectsupplierList}
            onIconClick={info => {
              if (this._isMounted) {
                return this.setState({ modalContact: info })
              }
            }}
            onIconWarning={info => {
              if (this._isMounted) {
                return this.setState({ modalWarning: info })
              }
            }}
            onAddMySupplier={info => {
              if (this._isMounted) {
                return this.setState({
                  modalAddMySupplier: info,
                  supplierDetail: info,
                })
              }
            }}
            mainDirectoryList={e => {
              // this.setList(e)
            }}
          />
        ))}
      </div>
    )
  }

  renderContactPersons = (contactpersons = []) => {
    if (contactpersons && contactpersons.length > 0) {
      const contactpersonActive = contactpersons.find(
        c => c.contact_person_activate === 1
      )
      if (contactpersonActive)
        return (
          <Section className="detail">
            <div className="title">{STRING.COMPANY_DETAIL}:</div>
            <Table className="contact-detail">
              <Table.THEAD>
                <Table.TR className="header">
                  <Table.TH className="full-name">{STRING.FULL_NAME}</Table.TH>

                  <Table.TH className="phone">{STRING.PHONE}</Table.TH>

                  <Table.TH className="email">{STRING.EMAIL_LABEL}</Table.TH>
                </Table.TR>
              </Table.THEAD>
              {contactpersons.map((e, i) => {
                return (
                  e.contact_person_activate === 1 && (
                    <Table.TBODY key={i}>
                      <Table.TR>
                        <Table.TD className="full-name">
                          {e.contact_person_full_name}
                        </Table.TD>

                        <Table.TD className="phone">
                          {e.contact_person_phone}
                        </Table.TD>

                        <Table.TD className="email">
                          {e.contact_person_mail}
                        </Table.TD>
                      </Table.TR>
                    </Table.TBODY>
                  )
                )
              })}
            </Table>
          </Section>
        )
    }
  }

  clearInputValue = event => {
    if (event && event.target && event.target.value) {
      event.target.value = ''
    }
  }

  _searchTagAdd(e) {
    const { searchTags } = store.getState()
    const value = e.target.value
    const trimValue = value.trim()
    const findSameTag = searchTags.findIndex(
      (i, e) => i.toLowerCase() === trimValue.toLowerCase()
    )
    const notSameTag = findSameTag === -1
    if (e.keyCode == 13 && value.length >= 3 && trimValue !== '') {
      // Check same Tag
      if (notSameTag) {
        store.dispatch(addSearchTag(trimValue))
        this.clearInputValue(e)
        if (this._isMounted) {
          this.setState({ searchTags, searchInput: '' }, () => {
            this.clearInputValue()
            this._onChangeFilters({ searchTags })
          })
        }
      }
    } else {
      if (this._isMounted) {
        this.setState({ supplierListLoading: false })
      }
    }
  }

  clearInputValue = () => {
    if (this.inputSearch && this.inputSearch.current) {
      this.inputSearch.current.state.value = ''
      this.inputSearch.current.cancel()
      if (this._isMounted) {
        this.setState({ supplierListLoading: true })
      }
    } else {
      throw new Error('not clear value on search input')
    }
  }

  _searchTagRemove(value) {
    const { searchTags } = store.getState()

    const trimValue = value.trim()
    store.dispatch(removeSearchTag(trimValue))
    this.clearInputValue()
    if (this._isMounted) {
      this.setState({ searchInput: '' }, () => {
        this._onChangeFilters({ searchTags })
      })
    }
  }
  renderSupplierDiscovery = () => {
    const { selectsupplierList } = this.state
    const { searchTags, selectTab } = store.getState()

    const totalSupplier =
      selectTab === 0
        ? this.state.supplierPage
          ? this.state.supplierPage.total_record
          : 0
        : this.state.mainDirectoryPage
        ? this.state.mainDirectoryPage.total_record
        : 0

    // const isOpenModalContact = !!this.state.modalContact
    const isOpenModalWarning = !!this.state.modalWarning
    const isOpenModalAddMySupplier = !!this.state.modalAddMySupplier
    const modalContact = this.state.modalContact || {}
    const modalWarning = this.state.modalWarning || {}
    const modalAddMySupplier = this.state.modalAddMySupplier || {}
    const renderPageTitle = () => {
      const handlerClickBreadcrumb = e => {
        return this.props.history.push(ROUTE_PATH.HOME.LINK)
      }
      return (
        <Section className="page-topbar">
          <Section className="page-header">
            <Section className="page-icon">
              <Image
                id="page_icon_buyer_management"
                src={ICONS['icon-supplier-discovery-white.svg']}
                alt="page icon"
              />
            </Section>
            <Section className="title-and-breadcrumb">
              <Section id="page_title_buyer_management" className="title">
                {STRING.SUPPLIER_DISCOVERY}
              </Section>
              <Breadcrumbs props={this.props} />
            </Section>
          </Section>
        </Section>
      )
    }
    const renderPageContent = () => {
      const funcRenderSidebarFilter = () => {
        return (
          <React.Fragment>
            <SidebarFilter onChange={this._onChangeSidebarFilter.bind(this)} />
            {/* <div className="separate-line"></div> */}
          </React.Fragment>
        )
      }
      const funcRenderTabs = () => {
        const funcRenderTabber = () => {
          const funcRenderTabsHeader = () => {
            return <></>
          }
          const funcInsideTabberFilter = () => {
            const funcSearchTags = () => {
              if (searchTags) {
                const handleClickItem = item => {
                  return this._searchTagRemove(item)
                }
                return searchTags.map(item => {
                  return (
                    <Tag
                      key={item}
                      onClickRemove={() => handleClickItem(item)}
                      text={item}
                    />
                  )
                })
              }
            }
            const funcDebounceInput = e => {
              if (this._isMounted) {
                return this.setState({
                  searchInput: e.target.value,
                  supplierListLoading: false,
                })
              }
            }

            return (
              <Section className="inside-filter">
                <Section className="filters">
                  <Section className="filter-item total-supplier">
                    <Section className="label">
                      <span>
                        {STRING.TOTAL_SUPPLIER} :{' '}
                        {formatNumberWithComma(totalSupplier)}
                      </span>
                      <div className="search-note">Minimum 3 characters</div>
                    </Section>
                    <DebounceInput
                      onKeyDown={this._searchTagAdd.bind(this)}
                      id="filter_search_input"
                      className="supplier-discovery"
                      placeholder="Supplier Name, TaxID"
                      type="text"
                      value={this.state.searchInput}
                      onChange={funcDebounceInput}
                      debounceTimeout={500}
                      element={InputSearch}
                      ref={this.inputSearch}
                    />
                  </Section>
                  <Section className="filter-item sort-by-wrapper">
                    <Section className="label">{STRING.SORT_BY}:</Section>
                    <SelectBox
                      onChange={this._onChangeSortBy.bind(this)}
                      id="category_filter"
                      className="category-filter"
                      value={this.state.sortByValue}
                      options={this.state.optionsSortBy}
                      isSearchable={false}
                      isClearable={false}
                    />
                  </Section>
                </Section>
                <Section className="search-tags">{funcSearchTags()}</Section>
              </Section>
            )
          }
          const funcTabberPanelsSupplier = () => {
            const funcSupplierList = () => {
              if (
                this.state.supplierList.length <= 0 &&
                this.state.supplierListLoading === false
              ) {
                return (
                  <Section className="no-result-found">
                    <Image src={ICONS['icon-ssr.png']} className="no-result" />
                    <p>No result found</p>
                  </Section>
                )
              } else {
                return this._renderSupplierList()
              }
            }
            const funcSupplierListLoading = () => {
              if (this.state.supplierListLoading) {
                return <Spinner />
              }
            }
            return (
              // <Tabber.TabPanel>
              //   {funcSupplierList()}
              //   {funcSupplierListLoading()}
              // </Tabber.TabPanel>
              <>
                {funcSupplierList()}
                {funcSupplierListLoading()}
              </>
            )
          }
          const funcTabberMainDirectory = () => {
            const funcMainDirectoryList = () => {
              if (
                !this.state.mainDirectoryList.length &&
                !this.state.mainDirectoryListLoading
              ) {
                return (
                  <Section className="no-result-found">
                    <Image src={ICONS['icon-ssr.png']} className="no-result" />
                    <p>No result found</p>
                  </Section>
                )
              } else {
                return this._renderMainDirectoryList()
              }
            }
            const mainDirectoryListLoading = () => {
              if (this.state.mainDirectoryListLoading) {
                return <Spinner />
              }
            }
            return (
              // <Tabber.TabPanel>
              //   {funcMainDirectoryList()}
              //   {mainDirectoryListLoading()}
              // </Tabber.TabPanel>
              <>
                {funcMainDirectoryList()}
                {mainDirectoryListLoading()}
              </>
            )
          }
          return (
            <Tabber
              className="supplier-discovery"
              selectedIndex={selectTab}
              onSelect={this._onChangeTab.bind(this)}
            >
              {/* {funcRenderTabsHeader()} */}
              {funcInsideTabberFilter()}
              {funcTabberPanelsSupplier()}
              {/* {funcTabberMainDirectory()} */}
            </Tabber>
          )
        }
        return (
          <Section className="supplier-list-wrapper">
            {funcRenderTabber()}
          </Section>
        )
      }
      return (
        <Section className="main-content">
          <Section className="content-body">
            {funcRenderSidebarFilter()}
            {funcRenderTabs()}
          </Section>
        </Section>
      )
    }
    const funcModalSupplierContact = () => {
      // const handleClick = e => {
      //   if (this._isMounted) {
      //     return this.setState({ modalContact: null })
      //   }
      // }
      return (
        <Modal
          id="contact_modal"
          className="supplier-contact theme-blue"
          isOpen={this.state.openModalContact}
        >
          <Modal.Header>{modalContact.company_name}</Modal.Header>
          <Modal.Body>
            <Section className="address">
              <div className="title">{STRING.COMPANY_ADDRESS}:</div>
              <div className="data">{`${modalContact.contact_address}`}</div>
            </Section>
            {this.renderContactPersons(modalContact.contact_person)}
          </Modal.Body>
          <Modal.Footer>
            <Button
              id="cancel_request_esg_modal"
              className="theme-border-gray close"
              onClick={() => {
                this.setState({ openModalContact: false })
                setTimeout(() => {
                  this.setState({ modalContact: null })
                }, 500)
              }}
            >
              {STRING.CLOSE}
            </Button>
          </Modal.Footer>
        </Modal>
      )
    }
    const funcModalAddtomysupplier = () => {
      const handleClick = e => {
        if (this._isMounted) {
          return this.setState({ modalAddMySupplier: null })
        }
      }
      return (
        <Modal
          id="popup_addtomysupplier_modal"
          className="addtomysupplier theme-blue"
          isOpen={isOpenModalAddMySupplier}
          modalWidth="575px"
        >
          <Modal.Header>Add To My Supplier</Modal.Header>
          <Modal.Body>
            <p className="default text-center">
              Are you sure to add to my supplier? <br />
              {modalAddMySupplier.company_name}
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button
              id="close_modal_history_id"
              className="theme-border-gray"
              onClick={handleClick}
            >
              Cancel
            </Button>
            <Button
              id="close_modal_history_id"
              className="theme-green"
              onClick={this._addSupplierList.bind(this)}
            >
              Confirm
            </Button>
          </Modal.Footer>
        </Modal>
      )
    }
    const funcWarningPopup = () => {
      // console.log({ modalWarning })
      if (modalWarning.company_supplier_discovery_status === 2) {
        const handlerClick = () => {
          if (this._isMounted) {
            return this.setState({
              modalWarning: null,
            })
          }
        }
        return (
          <Modal
            id="popup_warning_modal"
            className="popup warning theme-yellow"
            isOpen={isOpenModalWarning}
          >
            <Modal.Header>{modalWarning.company_name}</Modal.Header>

            <Modal.Body>
              <Image src={ICONS['icon-warning.svg']} className="warning" />

              <div className="warning-msg">{modalWarning.warning}</div>
            </Modal.Body>

            <Modal.Footer>
              <Button
                id="cancel_request_esg_modal"
                className="theme-border-gray close"
                onClick={handlerClick}
              >
                {STRING.CLOSE}
              </Button>
            </Modal.Footer>
          </Modal>
        )
      } else {
        return null
      }
    }
    return (
      <React.Fragment>
        <SupplierDiscoveryStyle>
          {renderPageTitle()}
          {renderPageContent()}
        </SupplierDiscoveryStyle>
        {funcModalSupplierContact()}
        {funcModalAddtomysupplier()}
        {funcWarningPopup()}
        <Loading loading={this.state.supplierListLoading} />
      </React.Fragment>
    )
  }
  render = () => this.renderSupplierDiscovery()
}
